const Patterns = (function () {
  const ALPHANUMERIC = /^[a-zA-ZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚŮÝŽäöüÄÖÜ0-9.,:?!()[\]\-*_/'"@ ]+$/;
  const ALPHANUMERIC_MESSAGE = {
    cs: 'smí obsahovat pouze alfanumerické znaky, .,:?!()[]-*_/\'&quot;@ a mezery',
    en: 'must contain only alphanumeric characters, .,:?!()[]-*_/\'&quot;@ and spaces',
  };

  const ACCENTS = /^[a-zA-ZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚŮÝŽäöüÄÖÜ ]+$/;
  const ACCENTS_MESSAGE = {
    cs: 'smí obsahovat pouze písmena a mezery',
    en: 'must contain only letters and spaces',
  };

  const ONLY_ACCENTS = /^[a-zA-ZáčďéěíňóřšťúůýžÁČĎÉĚÍŇÓŘŠŤÚŮÝŽäöüÄÖÜ]+$/;
  const ONLY_ACCENTS_MESSAGE = {
    cs: 'smí obsahovat pouze písmena',
    en: 'must contain only letters',
  };

  const LETTERS = /^[a-zA-Z ]+$/;
  const LETTERS_MESSAGE = {
    cs: 'smí obsahovat pouze písmena a mezery',
    en: 'must contain only letters and spaces',
  };

  const ONLY_LETTERS = /^[a-zA-Z]+$/;
  const ONLY_LETTERS_MESSAGE = {
    cs: 'smí obsahovat pouze písmena',
    en: 'must contain only letters',
  };

  const ONLY_LOWER_CASE = /^[a-z]+$/;
  const ONLY_LOWER_CASE_MESSAGE = {
    cs: 'smí obsahovat pouze malá písmena',
    en: 'must contain only lower case letters',
  };

  const ONLY_LOWER_CASE_WITH_NUMBERS = /^[a-z0-9]+$/;
  const ONLY_LOWER_CASE_WITH_NUMBERS_MESSAGE = {
    cs: 'smí obsahovat pouze malá písmena a číslice',
    en: 'must contain only lower case letters and numbers',
  };

  const ONLY_UPPER_CASE = /^[A-Z]+$/;
  const ONLY_UPPER_CASE_MESSAGE = {
    cs: 'smí obsahovat pouze velká písmena',
    en: 'must contain only upper case letters',
  };

  const ONLY_UPPER_CASE_WITH_NUMBERS = /^[A-Z0-9]+$/;
  const ONLY_UPPER_CASE_WITH_NUMBERS_MESSAGE = {
    cs: 'smí obsahovat pouze velká písmena a číslice',
    en: 'must contain only upper case letters and numbers',
  };

  return {
    ALPHANUMERIC,
    ALPHANUMERIC_MESSAGE,
    ACCENTS,
    ACCENTS_MESSAGE,
    ONLY_ACCENTS,
    ONLY_ACCENTS_MESSAGE,
    LETTERS,
    LETTERS_MESSAGE,
    ONLY_LETTERS,
    ONLY_LETTERS_MESSAGE,
    ONLY_LOWER_CASE,
    ONLY_LOWER_CASE_MESSAGE,
    ONLY_LOWER_CASE_WITH_NUMBERS,
    ONLY_LOWER_CASE_WITH_NUMBERS_MESSAGE,
    ONLY_UPPER_CASE,
    ONLY_UPPER_CASE_MESSAGE,
    ONLY_UPPER_CASE_WITH_NUMBERS,
    ONLY_UPPER_CASE_WITH_NUMBERS_MESSAGE,
  };
})();

export default Patterns;
